import script from "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=script&setup=true&lang=js"

import "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=style&index=0&id=5e3797ac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3797ac"]])

export default __exports__